export const Toggleable = {
	data() {
		return {
			active: false,
			closing: false,
		}
	},
	computed: {
		activeClass() {
			return (this.active) ? 'active' : '';
		},
		contentOpenClass() {
			return (this.active || this.closing) ? 'content-open' : '';
		},
		toggledContentTabindex() {
			return (this.active) ? 0 : -1;
		}
	},
	methods: {
		toggle() {
			this.active = !this.active;
			window.setTimeout(() => {
				this.toggleHeightChange();
			}, 350);
		},
		toggleHeightChange() {
			this.$emit(
				'toggle-height-change', 
				this.$refs.toggleItemWrapper, 
				this.$refs.toggleItemWrapper.clientHeight
			)
		},
		toggleableOnMounted() {
			this.toggleableHandleLinks();
			this.toggleHeightChange();
		},
		toggleableHandleLinks() {
			if (typeof this.$refs.toggleContentWrapperInner === 'undefined') return;
			const contentLinks = this.$refs.toggleContentWrapperInner.querySelectorAll('a');
			if (contentLinks) {
				contentLinks.forEach((link) => {
					link.tabIndex = (this.active) ? 0 : -1;
				})
			}
		}
	},
	mounted() {
		this.toggleableOnMounted();
	},
	watch: {
		active() {
			this.toggleableHandleLinks()
		}
	}
}